import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Card, CardContent, CardHeader, Avatar, Typography, TextField, Checkbox, FormControlLabel, Button, Grid } from '@mui/material';
import axios from 'axios';
import ImageUpload from "../../components/ImageUpload";

export default function Update() {
  const { state } = useLocation();
  const navigate = useNavigate();

  const {
    id,
    firstName,
    lastName,
    position,
    email,
    phoneNumber,
    employmentType,
    isActive,
    department,
    notes
  } = state;

  const [ime, setIme] = useState(firstName || "");
  const [prezime, setPrezime] = useState(lastName || "");
  const [pozicija, setPozicija] = useState(position || "");
  const [mail, setMail] = useState(email || "");
  const [telefon, setTelefon] = useState(phoneNumber || "");
  const [tipZaposlenja, setTipZaposlenja] = useState(employmentType || "");
  const [aktivan, setAktivan] = useState(isActive || false);
  const [odjel, setOdjel] = useState(department || "");
  const [napomena, setNapomena] = useState(notes || "");

  const updateAPIData = () => {
    axios.put(`https://smartlight.bhtelecom.ba:3000/api/workers/${id}`, {
      firstName: ime,
      lastName: prezime,
      position: pozicija,
      email: mail,
      phoneNumber: telefon,
      employmentType: tipZaposlenja,
      isActive: aktivan,
      department: odjel,
      notes: napomena
    }).then(() => {
      navigate('/dashboard/WorkersListAll');
    });
  };

  return (
    <div style={{ 
      backgroundColor: '#0b1446',  // tamno plava pozadina
      minHeight: '100vh',
      width: '100%',
      padding: '20px'
    }}>
      <Grid container justifyContent="center">
        <Card sx={{ maxWidth: 800, width: '100%', backgroundColor: '#1a237e', color: '#ffffff', borderRadius: 2, boxShadow: 3 }}>
          <CardHeader
            avatar={<Avatar sx={{ width: 60, height: 60 }}>{firstName ? firstName[0] : "U"}</Avatar>}
            title={<Typography variant="h6">{firstName} {lastName}</Typography>}
            subheader={<Typography variant="body2">{position}</Typography>}
          />
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <TextField
                  label="Ime"
                  value={ime}
                  onChange={(e) => setIme(e.target.value)}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  InputLabelProps={{ style: { color: '#ffffff' } }}
                  InputProps={{ style: { color: '#ffffff' } }}
                />
                <TextField
                  label="Prezime"
                  value={prezime}
                  onChange={(e) => setPrezime(e.target.value)}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  InputLabelProps={{ style: { color: '#ffffff' } }}
                  InputProps={{ style: { color: '#ffffff' } }}
                />
                <TextField
                  label="Pozicija"
                  value={pozicija}
                  onChange={(e) => setPozicija(e.target.value)}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  InputLabelProps={{ style: { color: '#ffffff' } }}
                  InputProps={{ style: { color: '#ffffff' } }}
                />
                <TextField
                  label="Email"
                  value={mail}
                  onChange={(e) => setMail(e.target.value)}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  InputLabelProps={{ style: { color: '#ffffff' } }}
                  InputProps={{ style: { color: '#ffffff' } }}
                />
                <TextField
                  label="Telefon"
                  value={telefon}
                  onChange={(e) => setTelefon(e.target.value)}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  InputLabelProps={{ style: { color: '#ffffff' } }}
                  InputProps={{ style: { color: '#ffffff' } }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  label="Tip zaposlenja"
                  value={tipZaposlenja}
                  onChange={(e) => setTipZaposlenja(e.target.value)}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  InputLabelProps={{ style: { color: '#ffffff' } }}
                  InputProps={{ style: { color: '#ffffff' } }}
                />
                <FormControlLabel
                  control={<Checkbox checked={aktivan} onChange={() => setAktivan(!aktivan)} sx={{ color: '#ffffff' }} />}
                  label="Aktivan"
                />
                <TextField
                  label="Odjel"
                  value={odjel}
                  onChange={(e) => setOdjel(e.target.value)}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  InputLabelProps={{ style: { color: '#ffffff' } }}
                  InputProps={{ style: { color: '#ffffff' } }}
                />
                <TextField
                  label="Napomena"
                  value={napomena}
                  onChange={(e) => setNapomena(e.target.value)}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  multiline
                  rows={4}
                  InputLabelProps={{ style: { color: '#ffffff' } }}
                  InputProps={{ style: { color: '#ffffff' } }}
                />
                <ImageUpload />
              </Grid>
            </Grid>
            <Button
              variant="contained"
              sx={{ mt: 3, backgroundColor: '#3949ab' }}
              onClick={updateAPIData}
            >
              Spasi promjene
            </Button>
          </CardContent>
        </Card>
      </Grid>
    </div>
  );
}
